"use strict";

var _accessibilityjs = require("accessibilityjs");

var _getOptions = require("./get-options.js");

var _getOptions2 = _interopRequireDefault(_getOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function handleError(error, opts) {
  var errorClassName = opts.errorClassName,
      onError = opts.onError;

  if (errorClassName) {
    error.element.classList.add(errorClassName);
  }
  if (onError) {
    onError(error);
  }
}

exports.onRouteUpdate = function (_ref, pluginOptions) {
  var location = _ref.location;

  if (process.env.NODE_ENV !== "development") {
    return;
  }
  var opts = (0, _getOptions2.default)(pluginOptions);
  // Wait to ensure page is rendered first.
  setTimeout(function () {
    (0, _accessibilityjs.scanForProblems)(document, function (error) {
      return handleError(error, opts);
    });
  }, 100);
};